import React from 'react';
import classNames from 'classnames';
import styles from './Tabs.module.scss';

export interface ITabClasses {
    activeHeader: string;
    tab?: string;
    tabTitle?: string;
    activeTab?: string;
    tabList?: string;
    activeLastTab?: string;
}

interface ITabProps {
    title: string | React.ReactElement;
    children: React.ReactElement;
}

interface ITabs {
    children: Array<React.ReactElement<ITabProps>>;
    tabClasses: ITabClasses;
    initSelectedTab?: number;
    onTabChange?(index: number): void;
}

export const Tabs: React.FC<ITabs> = ({ children, tabClasses, initSelectedTab, onTabChange }) => {
    const [selectedTab, setSelectedTab] = React.useState(initSelectedTab || 0);

    const { activeTab, tab, tabList, tabTitle, activeLastTab, activeHeader } = tabClasses;

    const isActive = (index: number) => selectedTab === index;

    const onClick = React.useCallback(
        (index: number) => () => {
            setSelectedTab(index);
            onTabChange?.(index);
        },
        [setSelectedTab, onTabChange]
    );

    return (
        <div className={styles.tabs}>
            <ul className={classNames(styles.tabsList, tabClasses.tabList)}>
                {children.map((item, index) => (
                    <li
                        key={index}
                        className={classNames(tab, { [activeHeader]: isActive(index) })}
                        onClick={onClick(index)}>
                        <div
                            className={classNames(tabTitle, {
                                [activeTab || '']: isActive(index),
                                [activeLastTab || '']: isActive(index) && children.length - 1 === index,
                            })}>
                            {item.props.title}
                        </div>
                    </li>
                ))}
            </ul>
            {children[selectedTab]}
        </div>
    );
};
